import { all, fork } from 'redux-saga/effects';
import authSaga from '../features/auth/store/authSaga.js';
import onboardingSaga from '../features/auth/store/onboardingSaga.js';
import coursesSaga from '../features/courses/store/coursesSaga.js';
import lessonSaga from '../features/lesson/store/lessonSaga.js';
import coachingSaga from '../features/coaching/store/coachingSaga.js';
import librarySaga from '../features/library/store/librarySaga.js';
import accountSaga from '../features/account/store/accountSaga.js';
import notificationsSaga from '../features/notifications/store/notificationsSaga.js';
import proctorSaga from '../features/proctoring/store/proctorSaga.js';
import progressSaga from '../features/progress/store/progressSaga.js';
import featureVisibilitySaga from '../features/appVisibility/store/featureVisibilitySaga.js';

export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(onboardingSaga),
    fork(coursesSaga),
    fork(lessonSaga),
    fork(coachingSaga),
    fork(librarySaga),
    fork(accountSaga),
    fork(notificationsSaga),
    fork(proctorSaga),
    fork(progressSaga),
    fork(featureVisibilitySaga),
  ]);
}
